export default "__VITE_ASSET__bb4c6810__"